import { render, staticRenderFns } from "./ClientProductList.vue?vue&type=template&id=a2c718b2&scoped=true&"
import script from "./ClientProductList.vue?vue&type=script&lang=js&"
export * from "./ClientProductList.vue?vue&type=script&lang=js&"
import style0 from "./ClientProductList.vue?vue&type=style&index=0&id=a2c718b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c718b2",
  null
  
)

export default component.exports